import EditAutomationOutput from './EditAutomationOutputContainer';

export { default as EditAutomationOutputModal } from './EditAutomationOutputModal';

export default EditAutomationOutput;
